// Sugalarm — app logo / icon.
//
// Cycle 34.15 introduced the bitmap-Logo pattern (replacing the cycle-9
// placeholder SVG); cycle 57 swapped it to the `sa_link.png` brand refresh.
// Cycle 396 swaps it again for the "Sugar Alarm" rebrand: the served bitmap
// is now `sugar-alarm-mark.png`, derived from `images/rebrand/mark.png`.
// The PNG ships under `web/public/` so Vite serves it at
// `/sugar-alarm-mark.png` at the root origin — no hashing (and so no
// cycle-33 immutable-assets cache), but the file is small enough that one
// cold fetch per session is fine.
//
// THE FILENAME CHANGED ON PURPOSE. These bitmaps are served unhashed, so
// reusing `sa_link.png` would have left every warm browser and every field
// kiosk showing the OLD silver shield until its cache happened to expire.
// A new path is the cache-bust.
//
// The source is cropped to its alpha bounding box (640 × 716, aspect 0.894)
// so it very nearly matches the outgoing bitmap's 0.871 — the rendered size
// is unchanged at every existing call site. Rendered inside a square box
// with `object-fit: contain`, so it centers cleanly inside whatever `size`
// the caller picked.

interface Props {
  size?: number;
  /** Optional alt text for accessibility. Defaults to "Sugar Alarm". */
  alt?: string;
}

export function Logo({ size = 48, alt = "Sugar Alarm" }: Props) {
  return (
    <img
      src="/sugar-alarm-mark.png"
      alt={alt}
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        objectFit: "contain",
        display: "block",
        flexShrink: 0,
      }}
    />
  );
}
